<template>
  <TabInner name="Component">
    ddd <slot />
  </TabInner>
</template>
